import { useContext, useEffect, useState } from "react"
import { Button } from "react-bootstrap"
import { Link, useNavigate } from "react-router-dom"
import { renderModal } from "../handlers"
import FormEditarUsuario from "./FormEditarUsuario"
import { UserContext } from "../../context/UserWrapper"
import FormBuscarUsuario from "./FormBuscarUsuario"


const Usuarios = () => {
  const [searchUserModalIsOpen, setSearchUserModalIsOpen] = useState(false)
  const [editModalIsOpen, setEditModalIsOpen] = useState(false)
  const [selectedRow, setSelectedRow] = useState(null)
  const { actions: ua } = useContext(UserContext)
  const navigate = useNavigate()

  useEffect(() => {
    if (!ua.hasPermission('usuarios.view')) {
      navigate('/')
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div>
      <div className="d-flex gap-4 align-items-center">
        <h3 className="mb-0">Usuarios</h3>
        {ua.hasPermission('usuarios.view') && (
          <Button onClick={() => setSearchUserModalIsOpen(true)}>Buscar Persona</Button>
        )}
        <Link to='/' className='my-auto  ms-auto me-1 btn btn-primary' style={{ maxHeight: '38px' }}>
          <span>Volver</span>
        </Link>
      </div>

      {renderModal(searchUserModalIsOpen, setSearchUserModalIsOpen, 'Buscar Usuario',
        <FormBuscarUsuario setSearchUserModalIsOpen={setSearchUserModalIsOpen} />
      )}

      {selectedRow && editModalIsOpen && renderModal(editModalIsOpen, setEditModalIsOpen, `Editar Usuario ${selectedRow?.id}`, <FormEditarUsuario usuario={selectedRow} setEditModalIsOpen={setEditModalIsOpen} />)}

    </div>
  )
}

export default Usuarios